import React from 'react';
import { EditorState, convertToRaw, ContentState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';

import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

import './RichTextEditor.css';

const debounce = (fn, delay) => {
  let timeout = null;
  return (...args) => {
    if (timeout) {
      clearTimeout(timeout);
    }
    timeout = setTimeout(() => {
      fn(...args);
      timeout = null;
    }, delay);
  }
};

class RichTextEditor extends React.Component {
  static createEditorState = value => {
    const contentBlock = htmlToDraft(value || '');
    const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
    return EditorState.createWithContent(contentState);
  };

  constructor(props) {
    super(props);
    this.state = {
      editorState: RichTextEditor.createEditorState(props.value),
      value: props.value,
      focused: false
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.value !== this.state.value) {
      this.setState({ value: nextProps.value, editorState: RichTextEditor.createEditorState(nextProps.value) });
    }
  }

  debouncedOnChange = debounce(() => {
    const { onChange } = this.props;
    if (onChange) {
      const { value, editorState } = this.state;
      const newValue = draftToHtml(convertToRaw(editorState.getCurrentContent()));
      if (value !== newValue) {
        this.setState({ value: newValue }, () => onChange(newValue));
      }
    }
  }, 300);

  onEditorStateChange = editorState => {
    this.setState({
      editorState
    });
    this.debouncedOnChange();
  };

  handleFocus = () => this.setState({ focused: true });
  handleBlur = () => this.setState({ focused: false });

  render() {
    const { editorState, focused } = this.state;
    return (
      <div>
        <Editor
          wrapperClassName={`text-editor${focused ? ' text-editor-focused' : ''}`}
          toolbar={{
            options: ['inline', 'list', 'textAlign', 'colorPicker', 'link', 'image', 'remove', 'history'],
            inline: { options: ['bold', 'italic', 'underline', 'strikethrough', 'monospace'] },
            list: { options: ['unordered', 'ordered'] }
          }}
          editorState={editorState}
          onEditorStateChange={this.onEditorStateChange}
          onFocus={this.handleFocus}
          onBlur={this.handleBlur}
          stripPastedStyles
        />
      </div>
    );
  }
}

export default RichTextEditor;



// WEBPACK FOOTER //
// ./src/components/basic/RichTextEditor.js